import axios from '~/utils/axios';

export const fetchChangelogById = (
  resource: string,
  profileId: string,
  changelogId: number | undefined
) => {
  return axios
    .get(`/${resource}/${profileId}/changelog/${changelogId?.toString()}`)
    .then((res) => res.data);
};

export const fetchChangelogs = (resource: string, profileId: string) => {
  const url = `/${resource}/${profileId}/changelog`;
  const query = resource === 'team' ? '?page=1&perPage=9999' : '';
  return axios.get(`${url}${query}`).then((res) => res.data);
};
